import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSchedules } from "hooks/useSchedules";

const useSlugConnector = () => {
   const { calendarEvents, reloadSchedules } = useSchedules();
   const params = useParams();

   const schedule = useMemo(() => {
      if (!calendarEvents?.length) return [];
      return calendarEvents?.find((event) => event.id === params.slug);
   }, [params.slug, calendarEvents]);

   return { schedule, reloadSchedules };
};

export default useSlugConnector;
